import React, { useState, useEffect } from "react";
import HeadingText from "components/common/HeadingText/HeadingText";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { Col, Container, Form, Row } from "reactstrap";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import {
  ILiveOpsPageProps,
  ILiveOpsPageState,
} from "interfaces/liveops.interface";
import "./LiveopsPage.scss";
import "react-datepicker/dist/react-datepicker.css";
import { acceptableFormats } from "config/constants";

import Toaster from "components/common/Toaster/Toaster";
import LoaderComponent from "components/common/Loader/Loader";
import UploadButtonComponent from "../../common/UploadButton/UploadButtonComponent";
import Datetime from "react-datetime";
import { isValidDate } from "utils/lib";

const LiveopsPage: React.FunctionComponent<ILiveOpsPageProps> = (
  props: ILiveOpsPageProps
) => {
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [liveOpsState, setLiveOpsState] = useState<ILiveOpsPageState>(
    props.dummyLiveOpsState || {
      deliveryDate: new Date().toString(),
      csvFile: null,
      csvFileName: props.dummyFileName ? props.dummyFileName : "",
    }
  );

  useEffect(() => {
    const { isError, error } = props;
    if (isError) {
      alert((error! as any).errors);
    }
  }, [props.isError, props.error]);

  useEffect(() => {
    props.deliveryDateUpdated && handleToaster(false, "Delivery Date Updated!");
  }, [props.deliveryDateUpdated]);

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleDeliveryDate = (value: any) => {
    value &&
      setLiveOpsState({
        ...liveOpsState,
        deliveryDate: value._d,
      });
  };

  //will write tests for it later
  const handleCSVInputChange = (file: File) => {
    if (file) {
      setLiveOpsState({
        ...liveOpsState,
        csvFile: file,
        csvFileName: file.name,
      });
    }
  };

  const handleCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setLiveOpsState({ ...liveOpsState, csvFileName: "", csvFile: null });
  };

  //need to write test for this too
  const handleSubmit = () => {
    if (liveOpsState.csvFile && liveOpsState.deliveryDate) {
      const data = new FormData();
      data.append("orderNumbers", liveOpsState.csvFile);
      data.append(
        "deliveryDate",
        Date.parse(liveOpsState.deliveryDate).toString()
      );
      props.updateDeliveryDate(data);
    }
  };

  const renderFormButton = () => {
    return (
      <ButtonComponent
        buttonClass="btn-primary handle-submit button-medium"
        buttonText={"Save"}
        onClickHandler={handleSubmit}
        isDisable={
          props.isLoading ||
          liveOpsState.deliveryDate === "" ||
          liveOpsState.csvFile === null
        }
      />
    );
  };

  const renderUploadCSVButton = () => {
    return (
      <div className="liveops--csv-container">
        <UploadButtonComponent
          id="upload-liveops-csv"
          buttonText={liveOpsState.csvFileName ? "" : "Upload .csv for orders"}
          fileFormat={acceptableFormats.csv}
          fileUploaded={!!liveOpsState.csvFileName}
          handleRemoveFile={handleCSVRemove}
          handleFileChange={handleCSVInputChange}
          classes="large-button"
        />
        <label className="liveops--csv-container-filename">
          {liveOpsState.csvFileName}
        </label>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <Row className="form-container">
        {props.isLoading && <LoaderComponent />}
        <Toaster
          showToaster={showToaster.isVisible}
          toasterClass={
            showToaster.isError
              ? "toaster toaster-bg-danger"
              : "toaster toaster-bg-success"
          }
        >
          {showToaster.message || ""}
        </Toaster>
        <FormSectionLayout subTitleText="Order details">
          <section
            className="form-group search-container"
            id="delivery-date-container"
          >
            <label className="block text-uppercase label">Delivery Date</label>
            <Datetime
              value={new Date(liveOpsState.deliveryDate)}
              onChange={handleDeliveryDate}
              inputProps={{ placeholder: "Select delivery date" }}
              isValidDate={isValidDate}
              closeOnSelect={true}
              closeOnClickOutside={true}
              timeFormat={false}
            />
          </section>
          <section className="liveops--buttons-container">
            {renderUploadCSVButton()}
            {renderFormButton()}
          </section>
        </FormSectionLayout>
      </Row>
    );
  };

  return (
    <Container fluid className="liveops--container">
      <Row>
        <Col lg="5">
          <div className="liveops--main-heading">
            <HeadingText text={"Live Ops"} isMainHeading={true} />
          </div>
        </Col>
      </Row>

      <Row className="form-container ml-0 mr-0">
        <Col xs="12">
          <Form>{renderForm()}</Form>
        </Col>
      </Row>
    </Container>
  );
};

export default LiveopsPage;
